var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCallCancel = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  color: "currentColor",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M3.124 17.759 17.758 3.125l-.884-.884-7.855 7.855a10.2 10.2 0 0 1-1.274-1.798l1.504-1.443L7.968 2.5H2.51l-.01.616v.217a14.1 14.1 0 0 0 3.716 9.565L2.24 16.875zM9.567 15.595a14 14 0 0 1-1.505-1.007l2.834-2.833q.39.269.806.5l1.444-1.503 4.354 1.28V17.5h-.833c-2.586 0-5.012-.693-7.1-1.905"
})));
export default SvgCallCancel;